<template>
  <component
    :is="type === 'link' ? 'a' : 'button'"
    :type="type === 'link' ? null : type"
    :target="blank ? '_blank' : null"
    class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full"
    :class="[
      active && 'bg-kale-60 text-kale-10',
      !active && 'hover:bg-kale-70 hover:text-kale-30 text-kale-40',
      !disabled && 'cursor-pointer',
      disabled && 'cursor-not-allowed',
    ]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    type?: 'button' | 'submit' | 'reset' | 'link'
    blank?: boolean
    active?: boolean
    disabled?: boolean
  }>(),
  {
    type: 'button',
  },
)
</script>
